import React from 'react';
import { useTranslation } from 'react-i18next';
import { ExamsResolutionCardAttempt } from './exams-resolution-card-attempt';
import { useQuery } from 'jsonapi-react';
import { Loader } from '@/components/custom/loader';
import { DialogTitle } from '@/components/ui/dialog';
import { AttemptModalHeader } from '@/components/custom/attempt';
import { Table, TableBody, TableCell, TableRow } from '@/components/ui/table';

export function ExamsResolutionAnswerKey(props) {
  const { t } = useTranslation();
  const { examId, amountQuestions, title = t('exams.examAnswer'), examData = [] } = props;
  const { data: questionBooksUsers, isLoading } = useQuery(examData.length > 0 ? false : `question_books_users?filter[current_user]=true&filter[question_book_id]=${examId}`);

  const attemptsToRender = examData.length > 0 ? examData : questionBooksUsers;

  return (
    <>
      <AttemptModalHeader>
        <DialogTitle>{title}</DialogTitle>

        <span className="text-neutral">
          <b className="text-primary-dark">{amountQuestions}</b> questões
        </span>
      </AttemptModalHeader>

      {isLoading ? (
        <Loader />
      ) : (
        <Table>
          <TableBody>
            {attemptsToRender.map((item, index) => (
              <TableRow>
                <TableCell className="mb-4 !border-0 !p-0 !shadow-none">
                  <ExamsResolutionCardAttempt
                    key={item.id || index}
                    index={index + 1}
                    attemptData={item}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </>
  );
}
